module.exports = __webpack_public_path__ + "insta.png?78b50d54da063764f35a5840e5381df6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/insta.png
// module id = 189
// module chunks = 0